import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'

import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { Discussion } from '../../../../../shared/interfaces/discussion.interface'
import { StripHtmlPipe } from '../../../../../shared/pipes/strip-html.pipe'
import { MetaService } from '../../../../../shared/services/meta.service'
import { DiscussionService } from '../../../services/discussion.service'
import { ExpertGroupPortalService } from '../../../services/expert-group-portal.service'

@Component({
  selector: 'app-discussion-detail',
  templateUrl: './discussion-detail.component.html',
  styleUrls: ['./discussion-detail.component.scss']
})
export class DiscussionDetailComponent implements OnInit {
  discussion: Discussion
  currentPath: string
  loadingRelatedDiscussions = true
  expertGroupPortal: ExpertGroupPortal

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private discussionService: DiscussionService,
    private metaService: MetaService,
    private expertGroupPortalService: ExpertGroupPortalService,
    private stripHtmlPipe: StripHtmlPipe
  ) {}

  ngOnInit(): void {
    // Wait to get the slug from the url and then get the discussion

    this.activatedRoute.params.subscribe((params: Params) => {
      this.currentPath = this.router.url

      const expertGroupPortalId: string = this.currentPath
        .split('/')
        .slice(-3)[0]

      this.expertGroupPortal =
        this.expertGroupPortalService.getExpertGroupPortalById(
          expertGroupPortalId
        )

      this.discussionService
        .show(params.slug)
        .then((discussionRes: Discussion) => {
          this.discussion = discussionRes
          if (this.discussion.relatedDiscussionIds?.length) {
            this.discussionService
              .listByIds(this.discussion.relatedDiscussionIds)
              .then((discussionsRes: Discussion[]) => {
                this.discussion.relatedDiscussions = discussionsRes
                this.loadingRelatedDiscussions = false
              })
          }

          this.metaService.setTags({
            title: this.discussion.metaTitle || this.discussion.title,
            description: this.stripHtmlPipe.transform(
              this.discussion.metaDescription || this.discussion.excerpt
            ),
            absoluteOgImage: this.discussion.image
              ? (this.discussion.image?.socialCard as string)
              : null,
            path: this.currentPath.substring(1)
          })
        })
    })
  }
}
